export default class AracKullanimSekli {
  kodu: any;
  adi: any;
  aktifMi: any;
}
